import { makeStyles } from '@material-ui/core/styles';

const useUndergroundStyles = makeStyles(() => ({
  '@global': {
    html: {
      height: '100%',
    },
    body: {
      height: '100%',
      margin: 0,
      padding: 0,
      overflow: 'hidden',
    },
    '#root': {
      height: '100%',
    },
    '.fullscreen': {
      width: '100% !important',
      height: '100% !important',
      display: 'flex',
      flexDirection: 'column',
    },

    '.fullscreen > *': {
      flex: 1,
      minHeight: 0,
      minWidth: 0,
      display: 'flex',
      flexDirection: 'column',
    },
  },
  appBody: {
    display: 'flex',
    height: 'calc(100vh - 48px)',
    minHeight: 0,
    overflow: 'hidden',
  },
  appSideMenu: {
    display: 'flex',
    flex: '0 0 auto',
    height: '100%',
    backgroundColor: '#f9f9f9',
  },

  sideMenuInner: {
    display: 'flex',
    height: '100%',
    overflowY: 'hidden',
    transition: 'width 0.5s ease',
    willChange: 'width',
  },

  sideMenuToggleContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    height: '100%',
  },

  sideMenuToggleIcon: {
    cursor: 'pointer',
    marginTop: 72,
    padding: 4,
    transition: 'transform 300ms ease',
    borderRadius: '4px 0 0 4px',
    backgroundColor: '#ffffff',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.2)',
  },

  appMain: {
    flex: '1 1 auto',
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#ffffff',
    padding: '8px',
    overflow: 'hidden',
  },
}));

export default useUndergroundStyles;
